<template>
  <section>
    <a class="linkTituloSeccion" href="#" @click="change">
      <div :class="'exp-' + expanded" class="tituloSeccion">
        <span v-if="expanded"
          ><fai :icon="['fas', 'angle-down']" class="fa-fw"
        /></span>
        <span v-else><fai :icon="['fas', 'angle-right']" class="fa-fw"/></span>
        {{ titulo }}
      </div>
    </a>
    <slot v-if="expanded" />
  </section>
</template>

<script>
export default {
  props: {
    titulo: { type: String, required: true },
  },
  data() {
    return {
      expanded: this.$store.state.displayBiggerThanPhone,
    };
  },
  methods: {
    change() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloSeccion {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
}

.linkTituloSeccion {
  text-decoration: none;
  :hover {
    text-decoration: none;
    cursor: pointer;
  }
  :active {
    text-decoration: none;
    cursor: pointer;
  }
}

li {
  color: white;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

a {
  color: white;
  text-decoration: none;
}

.exp-false {
  border-bottom: 1px solid #666;
}
</style>
